(function() {
    'use strict';

    angular.module('app.directive', []);
})();
